export const wordsRace = [
"Экспе|диция",
"Соревно|вание",
"Болель|щик",
"Пьеде|стал",
"Фи|ниш",
"Награж|дение",
"Хло|пушка",
"Ме|даль",
"Ку|бок",
"Сту|пенька",
"Спа|сение",
"Участ|ник",
"Пригла|шение",
"Пере|менная",
"Пара|метр",
"Алго|ритм",
"Дей|ствие"];